// extracted by mini-css-extract-plugin
export var avatarContainer = "_gc-0";
export var avatarTypingWave = "_gc-i";
export var gray = "_gc-f";
export var green = "_gc-c";
export var icon = "_gc-9";
export var image = "_gc-1";
export var lg = "_gc-6";
export var md = "_gc-5";
export var presenceDot = "_gc-b";
export var red = "_gc-d";
export var sm = "_gc-4";
export var status = "_gc-a";
export var typingDot = "_gc-h";
export var typingPill = "_gc-g";
export var xl = "_gc-7";
export var xs = "_gc-3";
export var xxl = "_gc-8";
export var xxs = "_gc-2";
export var yellow = "_gc-e";